import type { StaticEntityType } from "@config";
import type { IMediaFile } from "@/shared/types";

export enum MediaLibStaticFolderEnum {
  Website = "website",
  Import = "import",
}

export enum MediaLibCategoryEnum {
  AllFiles = "all_files",
  Images = "images",
  Videos = "videos",
  BrandAssets = "brand_assets",
  Website = "website",
  Import = "import",
  StockImages = "stock_images",
  StockVideos = "stock_videos",
  LogoFinder = "logo_finder",
  AiGenerate = "ai_generate",
  Gifs = "gifs",
  Archive = "archive",
}

type IMediaFrom =
  | "my-library"
  | "stock-image"
  | "stock-video"
  | "logo-finder"
  | "ai-generate"
  | "gifs";

export interface IMediaLibDialogItem {
  id: string;
  url: string;
  type: "image" | "video" | "logo";

  mediaFrom: IMediaFrom;
  mediaFile?: IMediaFile;

  shouldUpload?: boolean;
}

export interface IMediaLibUploadingFile {
  id: string;
  type: MediaLibCategoryEnum;
  index: number;
  folderId?: string | null;
}

export interface IMediaLibDialogResponse {
  id: string;
  type: "image" | "video" | "logo";

  mediaFile: IMediaFile;
  mediaFrom: IMediaFrom;
}

export interface IMediaLibDialogItem {
  id: string;
  url: string;
  type: "image" | "video" | "logo";

  mediaFrom: IMediaFrom;
  mediaFile?: IMediaFile;

  shouldUpload?: boolean;
}

export enum MediaLibPresetEnum {
  All = "all",
  OnlyImages = "only-images",
  OnlyVideos = "only-videos",
}

export enum MediaPanelTabEnum {
  StockImages = "stock-images",
  StockVideos = "stock-videos",
  MediaLib = "media-lib",
  LogoFinder = "logo-finder",
  Gifs = "gifs",
  AiGenerate = "ai-generate",
}

export type TElement = {
  category: string;
  element: string;
  json: StaticEntityType;
  order: number;
  previewImage: string | null;
  id: string;
};
